<nb-layout>
    <nb-sidebar responsive>
        <app-side-search></app-side-search>
    </nb-sidebar>
    <nb-layout-column class="colored-column-info">
        <nb-card>
            <nb-card-body [nbSpinner]="loading">
                <div class="row" infinite-scroll>
                    <div class="col-md-4 col-lg-4 mb-4" *ngFor="let bien of resultSearchT | slice:0:10">
                        <div class="feature-carousel" style="margin-top: 25px;">
                            <div class="feature-item">
                                <app-poperty-card [top]="bien"></app-poperty-card>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!datafound"
                        class="card d-flex justify-content-center align-items-center mx-auto border-0"
                        style="width: 30%; min-height: 200px;">
                        <img [src]="noResultImage" alt="Data not found" class="img-fluid"
                            style="max-width: 100%; height: auto;" />
                    </div>
                </div>
                <hr>
                <div class="search-results">
                    <h5>{{msgresult}} <b *ngIf="nbresult>0">{{nbresult}}</b></h5>
                </div>
            </nb-card-body>
        </nb-card>
        <app-footer></app-footer>
    </nb-layout-column>
</nb-layout>